module.exports = __webpack_public_path__ + "img/img20.3929bca3.png";